<template>
  <div class="font-h6 blackfriday-package">
    <div class="blackfriday-background">
      <img src="@/assets/img/blackfriday-gifts.png" alt="" />
    </div>
    <div class="align-center-xs relative" style="z-index: 2; margin-top: -50px">
      <h4 class="strong color-black align-center mb-0">Growth</h4>
      <h6 class="align-center strong mb-0">For Email + Linkedin Outreach</h6>
      <br /><br />

      <div style="text-decoration: line-through; font-size: 24px" class="align-center strong mb-5">Normal: $149</div>
      <div class="align-center">
        <div class="inline-block">
          <h1 class="mb-0 strong" style="font-size: 48px; line-height: 1em">Now: $89<span style="font-size: 20px; line-height: 1em">.4</span></h1>
          <p class="font-body align-right">per month</p>
        </div>
      </div>

      <div class="my-20">
        <p class="align-center">Save 40% for first 3 months</p>
        <div class="align-center">
          <!-- Curent tier -->
          <button
            v-if="billing.subscription && billing.subscription.plan_type == 'growth_' + billing_cycle"
            class="btn color-black div-border no-border btn-large strong free-height py-10 max-full-width"
            style="width: 300px; background-color: #f0c419"
            @click="$emit('switch', 'growth')">
            <span class="font-h5 strong">Current tier</span>
          </button>

          <!-- Switch plan -->
          <button
            v-else-if="billing.subscription"
            class="btn btn-primary btn-large no-border strong free-height py-10 max-full-width"
            v-ripple
            style="width: 300px"
            @click="$emit('switch', 'growth')">
            <span class="font-h5 strong">SUBSCRIBE</span>
          </button>

          <!-- Selected plan -->
          <button
            v-else-if="show_upgrade_form"
            class="btn btn-warning btn-large no-border strong free-height py-10 max-full-width"
            style="width: 300px; background-color: #f0c419">
            <span class="font-h5 strong">SELECTED</span>
          </button>

          <!-- Subscribe plan -->
          <button
            v-else
            class="btn btn-blackfriday btn-large no-border free-height py-10 max-full-width"
            v-ripple
            style="width: 300px"
            @click="$emit('choose', 'growth', 'upgrade')">
            <span class="font-h5">GET BLACK FRIDAY DEAL 👉</span>
          </button>
        </div>
      </div>

      <br />

      <div class="align-center">
        <div class="inline-block align-left">
          <h5 class="strong mb-15 color-black font-h5s">All in Entry, plus +</h5>
          <div class="inline-block">
            <div v-for="p in profits" :key="p" class="flex items-center mb-15">
              <h6 class="mb-0 flex-auto" :class="{ strong: p.startsWith('Linkedin') }">{{ p }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrowthBlackfriday",
  components: {},
  props: {
    billing: Object,
    billing_cycle: String,
    show_upgrade_form: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      profits: [
        "1000 AI Sales videos + AI Voice Cloning",
        "Linkedin Heyreach native integration",
        "Screen recording 60 min + Scheduling",
        "Sales academy",
        "Premium support",
        "All integrations available",
        "Add Minutes for $0.15/min",
      ],
    };
  },
  async mounted() {},
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    the_plan() {
      let p = this.billing.packages.find((p) => p.plan_type == "growth_" + this.billing_cycle);
      if (p) return p;
      return {};
    },
    price() {
      if (this.the_plan && this.the_plan.plan_price) {
        let price = this.the_plan.plan_price.split("/")[0];
        return price * this.the_plan.minimum_seats;
      } else return "..";
    },
    price_description() {
      if (this.the_plan.billed == "monthly") return "per month";
      else if (this.the_plan.billed == "yearly") return "per year";
      else return "..";
    },
  },
  methods: {},
};
</script>
